import React, { useState } from "react";

import {
    View,
    Text,
    SafeAreaView,
    Image,
    TouchableOpacity,
    Platform,
    ScrollView,
    Dimensions,
    Button,
  } from "react-native";
import { Entypo } from "@expo/vector-icons";
import WideButton from "../../commonComponents/wideButton";
import getPlatformType from "../../helpers/getPlatform";
import { useNavigation } from "@react-navigation/native";
import { AntDesign } from "@expo/vector-icons";
import CustomPopUp from "./../../commonComponents/customPopUp/customPopUp";

import {
    Container,
    InnerContainer,
    Heading,
    AddDocBtnBox,
    HeadingText,
    ListBox,
    DocumentBox,
    DocName,
    DocNameText,
    DocShare,
    DocShareText,
    DocRemove,
    DocRemoveText,
    DocDate,
    BackBtnBox,
    DocBoxLeft,
    DocBoxRight,
    DocDateText,
    ButtonFooter,
    MainContent,
  } from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { validateAssetsUrl } from "../../helpers/regex";
const layoutType = getPlatformType();
import {
    fetchDoc,
    updateSharedStatusOfDoc,
    deleteDoc,
  } from "../../redux/actions/auth";

import { COLORS } from "../../constants/colorPallete";
import { openUrlHelpers } from "../../helpers/openDocHelpers";
const RentalDocs =(props)=>{
    var navigation =useNavigation();
    var documents=useSelector(state=>state.authReducer?.docs);
    var dispatch=useDispatch();
    const [docToRemove,setRemoveDoc]=useState('');
    const [popUpIsVisible,setShowPopup]=useState(false);
   
    const  modifyDate = (date) => {
        return date.substr(0, 10).split("-").join("/");
      };

   const deleteDocument = (data) => {
        dispatch(deleteDoc(data?.document_id))
        setRemoveDoc(null);
      };
   const openDoc = (doc) => {
    openUrlHelpers(doc.url)
        // if (Platform.OS === "web") {
        //   if (validateAssetsUrl(doc.url)) {
        //     window.open(doc.url);
        //   } else {
        //     window.open("http://assets.openbrix.co.uk/" + `${doc.url}`);
        //   }
        // }
      };
   const updateShareStatus = (data) => {

    dispatch(updateSharedStatusOfDoc(data?.document_id, !data?.isShared))
     };    

    return(
      <View style={{flex:1,alignSelf:'flex-start',padding:20,width:'100%'}}>
          <Text style={{fontSize:16,fontWeight:'bold'}}>Rental Documents</Text>
          <Text style={{fontSize:14,marginVertical:10}}>{`All your rental related documents for your current rental have been added for your convenience.`}</Text>
        
                <ListBox>
                  {documents?.data?.rentalDocuments.length ? (
                    <React.Fragment>
                      {documents?.data?.rentalDocuments.map((doc) => (
                        <DocumentBox>
                          <DocBoxLeft>
                            <DocName>
                              <DocNameText 
                                   id={"RENTAL-FILE-NAME"}
                              onPress={() => openDoc(doc)}>
                                {doc.name}
                              </DocNameText>
                            </DocName>

                           
                          </DocBoxLeft>
                          <DocBoxRight>
                          <DocDate 
                           id={"RENTAL-FILE-DATE"}
                          onPress={() => openDoc(doc)}>
                              <DocDateText>
                                {doc?.date && modifyDate(doc.date)}
                              </DocDateText>
                              <Entypo
                                name="chevron-right"
                                size={22}
                                color={COLORS.orange}
                              />
                            </DocDate>
                          </DocBoxRight>
                        
                        </DocumentBox>
                      ))}
                    </React.Fragment>
                  ) : null}
                </ListBox>
             
                <CustomPopUp
          loading={popUpIsVisible}
          primaryButtonText={"Sure"}
          secondaryButtonText={"cancel"}
          primaryText={"Remove Doc?"}
          secondaryText={" Are you sure you want to remove Doc?"}
          onPrimaryButtonPress={() => {
              setShowPopup(false)
              deleteDocument(docToRemove);
          }}
          onSecondaryButtonPress={() => {
            setShowPopup(false)
          }}
        />

      </View>  
    )
}
export default RentalDocs;